import { Card, CardBody, Spinner } from '@chakra-ui/react'
import PageHeader from '../../../components/PageHeader'
import Empty from '../../../components/Empty'
import useSWR from 'swr'
import { useSnapshot } from 'valtio'
import tableStore from '../../../lib/store/product_table'
import { serialize } from '../../../network/request'
import { useNavigate, useParams } from 'react-router-dom'
import ProductService from '../../../network/services/product'
import ProductTable from './ProductTable'
const ProductsPage = () => {
  const navigate = useNavigate()
  //   const primaryAction = (
  //     <Button
  //       key='add'
  //       type='primary'
  //       onClick={() => {
  //         navigate('/admin/dashboard/invitations/new')
  //       }}
  //     >
  //       アフィリエイトを招待する
  //     </Button>
  //   )

  return (
    <PageHeader title='商品一覧'>
      <Card>
        <CardBody>
          <ProductTableWrapper />
        </CardBody>
      </Card>
    </PageHeader>
  )
}

const ProductTableWrapper = () => {
  const { state } = useSnapshot(tableStore)

  // use this to preload
  const { data: response, error } = useSWR(
    serialize(ProductService.getAll, {
      page: 1,
      limit: state.pageSize,
    })
  )

  if (error) {
    console.log(error)
    return <Empty description={error?.message ?? 'Please try again later'} />
  }

  if (!response) {
    return <Spinner />
  }

  const { total } = ProductService.toPaginate(response)

  return (
    <>
      <ProductTable total={total} />
      {/* preload next page */}
      {state.currentPage * state.pageSize < total && (
        <div style={{ display: 'none' }}>
          <ProductTable total={total} overridePage={state.currentPage + 1} />
        </div>
      )}
    </>
  )
}

export default ProductsPage
